import React from 'react';
// Status indicator component (defined outside to prevent re-renders)
const StatusIndicator = ({ status, size = 'md' }) => {
  const sizeClasses = {
    sm: 'w-2 h-2',
    md: 'w-3 h-3',
    lg: 'w-4 h-4'
  };

  const colorClasses = {
    passed: 'bg-green-500',
    failed: 'bg-red-500',
    running: 'bg-blue-500 animate-pulse',
    skipped: 'bg-yellow-500'
  };

  return (
    <span className={`inline-block rounded-full ${sizeClasses[size]} ${colorClasses[status] || 'bg-gray-300'}`} />
  );
};

export default StatusIndicator;
